import client from './client';

const Attachments = {
  getFiles(anketId) {
    return client.get(`/ankets/${anketId}/attachments`);
  },
};

export default Attachments;
